import React from "react";
import { UseFormRegister } from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";
type Inputs = any;

interface Props {
  register: UseFormRegister<Inputs>;
  errors: any;
  name: string;
  placeholder: string;
  label: string;
  type: string;
  translateId?: string;
  disabled?: boolean;
  printEnabled?: boolean;
}

const Input: React.FC<Props> = ({
  register,
  errors,
  name,
  placeholder,
  label,
  type,
  translateId,
  disabled,
  printEnabled = false,
}) => {
  const { t } = useTranslation();
  return (
    <div className="grid md:grid-cols-2 grid-cols-1 w-full gap-[5px] md:gap-0">
      <label htmlFor={name} className="font-normal text-xl text-[#1E408E]">
        <Trans t={t}>{label}</Trans>
      </label>
      <div className="pr-10 grid">
        <div className="flex flex-row justify-evenly gap-x-4">
          <input
            type={`${type}`}
            {...register(`${name}`)}
            className="w-full h-12 border border-[#8692A6] rounded p-2"
            disabled={disabled}
            placeholder={t(`${placeholder}`)}
          />
          {printEnabled && (
            <input
              type="checkbox"
              {...register(`print${name}`)}
              defaultChecked
              id={`${name}`}
            />
          )}
        </div>
        {errors[name] && (
          <p className="text-red-500 text-xs">
            <Trans t={t}>{errors[name]?.message}</Trans>
          </p>
        )}
      </div>
    </div>
  );
};

export default Input;
